import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { AirwallexTransferStatus } from './airwallex-transfer.status';

export const AirwallexTransferSchema = WithBaseEntitySchema(
    z.object({
        airwallexBeneficiaryId: z.string(),
        transferId: z.string().optional(),
        accountId: z.string().optional(),
        deduplicationId: z.string(),
        transactionId: z.string(),
        status: z.string(EnumSchema(AirwallexTransferStatus)),
        amount: z.number(),
        currency: z.string(EnumSchema(Currency)),
        bankAccount: z.string().optional(),
        reference: z.string().optional(),
        requestId: z.string().optional(),
        description: z.string().optional(),
    }),
).strict();

export class AirwallexTransfer extends FromSchema(AirwallexTransferSchema) implements BaseEntity {
    id: string;

    airwallexBeneficiaryId: string; //airwallex beneficary ID
    transferId?: string;
    accountId: string; //connected account id
    deduplicationId: string; //transaction reference
    transactionId: string;
    status: AirwallexTransferStatus;
    amount: number;
    currency: Currency;
    bankAccount?: string;
    reference?: string;
    requestId?: string;
    description?: string;

    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export class MultiTenantAirwallexTransfer extends AirwallexTransfer {}
